import * as React from 'react';
import { connect } from 'react-redux';

import {
    Col,
    Container,
    Row
} from 'reactstrap';

import { PortalHeader } from '../PortalHeader';

import { ApplicationState } from '../../Store';

import { GetPortalLoginText } from '../../Store/PortalAssets';

import { StrongboxLogo } from '../Utils/StrongboxLogo';

import { PortalTextLogin } from '../../Models/Api/strongbox.financialportal';
import { PortalFlow } from '../../Utils/PortalTypes';

type InjectedReduxState = {
    portalLoginText?: PortalTextLogin;
};

type InjectedActionCreators = {
};

type BasicStrongboxContentContainerProps = {
    children?: React.ReactNode;
    flow: PortalFlow;
};

type Props = BasicStrongboxContentContainerProps & InjectedActionCreators & InjectedReduxState;

const BasicStrongboxContentContainerComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        children,
        flow,
        portalLoginText,
    } = props;

    const containingDivClass = `full-screen-region lender-region content-region control-region control-region-lender`;

    if (!portalLoginText) {
        return (<React.Fragment></React.Fragment>);
    }
    else {
        return (
            <div>
                <PortalHeader 
                    hideMenu={true} 
                    flow={flow}
                />
                <div className={containingDivClass} >
                    <Container className={'strongbox-basic-content-container'}>
                        <Row>
                            <Col>
                                <StrongboxLogo 
                                    loginText={portalLoginText}
                                />
                            </Col>
                        </Row>
                        {children}
                    </Container>
                </div>
            </div>
        );
    }
}

export const BasicStrongboxContentContainer = connect<InjectedReduxState, InjectedActionCreators, BasicStrongboxContentContainerProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            portalLoginText: GetPortalLoginText(appState),
        };

        return result;
    }
)(BasicStrongboxContentContainerComponent);
